import angular from "angular";
import LibraryTariffsPageComponent from "./library-tariffs-page/library-tariffs-page.component";
import TariffFormComponent from "./tariff-form/tariff-form";
import ImportTariffsCsvModalComponent from "./library-tariffs-csv-modal/library-tariffs-csv-modal.component";

const LibraryTariffsModule = angular
  .module("modules.libraryTariffs", [])
  .component("libraryTariffsPage", LibraryTariffsPageComponent)
  .component("importTariffCsvModal", ImportTariffsCsvModalComponent)
  .component("tariffForm", TariffFormComponent);

export default LibraryTariffsModule;
